import { Box, Container, Grid, Typography } from '@mui/material';

interface JobScheduleProps {
  scheduleDayArrayMapped: string[];
  scheduleTimeArray: string[];
}

const JobSchedule = ({ scheduleDayArrayMapped, scheduleTimeArray }: JobScheduleProps) => {
  return (
    <Container maxWidth="md" sx={{ pt: 1 }}>
      <Typography variant="h2" mb={2}>
        Job schedule
      </Typography>
      <Grid container>
        {scheduleDayArrayMapped.map((value, index) => (
          <Grid container item xs={12} key={value}>
            <Grid item xs={4} md={2} key={value}>
              <Box fontSize="1rem" m={1} ml={0} fontWeight="bold">
                {value}
              </Box>
            </Grid>
            <Grid item xs={8} key={scheduleTimeArray[index]}>
              <Box fontSize="1rem" m={1}>
                {scheduleTimeArray[index]}
              </Box>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default JobSchedule;
